import {
  BeaconReadingsCellRenderer,
  LinkCellRenderer,
  OnlineStatusCellRenderer,
  PlacesCellRenderer,
} from '@components';
import { getFormattedDateTime } from '@utils';

// ASSET LIST PAGE
export const assetColumnDefs = [
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: OnlineStatusCellRenderer,
    width: 75,
    maxWidth: 75,
    minWidth: 75,
    headerClass: 'pe-2',
    tooltipValueGetter: (params) => {
      const status = params.value;
      if (status === 3)
        return 'No Check-Ins: Either no Beacons are attached or attached Beacons never checked in.';
      if (status === 2) return 'Partially Online: Some Beacons Online and some Offline.';
      if (status === 1) return 'Online Asset: All Beacons attached are Online.';
      if (status === 0) return 'Offline Asset: All Beacons attached are Offline.';
      return null;
    },
  },
  {
    headerName: 'Name',
    field: 'name',
    colId: 'name',
    cellRenderer: ({ data }) => {
      if (data.name) {
        return <LinkCellRenderer to={`/assets/${data.id}`} text={data.name} />;
      } else {
        return '--';
      }
    },
  },
  {
    headerName: 'Location',
    field: 'location.places',
    colId: 'place',
    cellRenderer: PlacesCellRenderer,
    sortable: true,
  },
  {
    headerName: 'Last Check-In',
    field: 'lastCheckin',
    valueFormatter(params) {
      return getFormattedDateTime(params.value);
    },
    sortable: true,
  },
  {
    headerName: 'Readings',
    field: 'beacons',
    colId: 'readings',
    cellRenderer: BeaconReadingsCellRenderer,
    valueFormatter(params) {
      return params.value;
    },
    sortable: false,
  },
];
